<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc full-character-formatting" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/prologue"><span class="item-title-text">Prologue</span></a></p>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-leading-number has-no-author has-children">
<p class="item-title"><span class="item-number">I. </span><a href="#/part001"><span class="item-title-text">Arrival</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part001chapter0700hoursintothelight"><span class="item-title-text">0700 Hours: Into the Light</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part001chapter0800hoursconsult" title="Link target outside of Sample"><span class="item-title-text">0800 Hours: Consult</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part001chapter0900hoursweirdfriends" title="Link target outside of Sample"><span class="item-title-text">0900 Hours: Weird Friends</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part001chapter1000hoursstarchild" title="Link target outside of Sample"><span class="item-title-text">1000 Hours: StarChild</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part001chapter1100hoursurgentcare" title="Link target outside of Sample"><span class="item-title-text">1100 Hours: Urgent Care</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part001chapter1200hourshighnoon" title="Link target outside of Sample"><span class="item-title-text">1200 Hours: High Noon</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-leading-number has-no-author has-children">
<p class="item-title"><span class="item-number">II. </span><span href="#/part002" title="Link target outside of Sample"><span class="item-title-text">Transfer</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1300hourstheemissary" title="Link target outside of Sample"><span class="item-title-text">1300 Hours: The Emissary</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1400hourscheckin" title="Link target outside of Sample"><span class="item-title-text">1400 Hours: Check-In</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1500hoursyetanotherweirdfriend" title="Link target outside of Sample"><span class="item-title-text">1500 Hours: Yet Another Weird Friend</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1600hourscultclassic" title="Link target outside of Sample"><span class="item-title-text">1600 Hours: Cult Classic</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1700hoursboilerplate" title="Link target outside of Sample"><span class="item-title-text">1700 Hours: Boilerplate</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part002chapter1800hoursnuclearoption" title="Link target outside of Sample"><span class="item-title-text">1800 Hours: Nuclear Option</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-leading-number has-no-author has-children">
<p class="item-title"><span class="item-number">III. </span><span href="#/part003" title="Link target outside of Sample"><span class="item-title-text">Raid</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter1900hourslogistics" title="Link target outside of Sample"><span class="item-title-text">1900 Hours: Logistics</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter2000hourshorsdecombat" title="Link target outside of Sample"><span class="item-title-text">2000 Hours: Hors de Combat</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter2100hourssurprisepackages" title="Link target outside of Sample"><span class="item-title-text">2100 Hours: Surprise Packages</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter2200hoursrampup" title="Link target outside of Sample"><span class="item-title-text">2200 Hours: Ramp Up</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter2300hoursbackinthegame" title="Link target outside of Sample"><span class="item-title-text">2300 Hours: Back in the Game</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part003chapter2400hoursmidnight" title="Link target outside of Sample"><span class="item-title-text">2400 Hours: Midnight</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-leading-number has-no-author has-children">
<p class="item-title"><span class="item-number">IV. </span><span href="#/part004" title="Link target outside of Sample"><span class="item-title-text">Transfiguration</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0200hoursicorinthians1551" title="Link target outside of Sample"><span class="item-title-text">0200 Hours: I Corinthians 15:51</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0300hourstheshepherd" title="Link target outside of Sample"><span class="item-title-text">0300 Hours: The Shepherd</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0400hoursmeaculpa" title="Link target outside of Sample"><span class="item-title-text">0400 Hours: Mea Culpa</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0500hourscomeletusreasontogether" title="Link target outside of Sample"><span class="item-title-text">0500 Hours: Come, Let Us Reason Together</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0600hourstheendofallthings" title="Link target outside of Sample"><span class="item-title-text">0600 Hours: The End of All Things</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/part004chapter0700hoursdawnsearlylight" title="Link target outside of Sample"><span class="item-title-text">0700 Hours: Dawn’s Early Light</span></span></p>
</div>
</div>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="item-title-text">Epilogue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="item-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/afterword" title="Link target outside of Sample"><span class="item-title-text">Afterword</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/theotherafterwordkayliesgifts" title="Link target outside of Sample"><span class="item-title-text">The Other Afterword: Kaylie’s Gifts</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="item-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/otherwordfirepresstitlesbybilldesmedt" title="Link target outside of Sample"><span class="item-title-text">Other WordFire Press Titles By Bill DeSmedt</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?105f57fc